import { getRequest, postRequest } from "../RestServices";
import {
  ReportsCameraData,
  ReportsDeviceData,
  ReportsOpportunityHistory,
  ReportsVTUData,
  Reports360JobsData,
  Reports360WorkticketsData,
  Reports360JobsCsvData,
  Reports360WorkticketsCsvData,
} from "../../api/reports/url";
import { CFWARRANTYSTATUS } from "../../api/VTU/url";

export const opportunityHistory = async (payload) => {
  try {
    const _response = await postRequest(ReportsOpportunityHistory, payload);
    const _OpportunityDetails = _response?.data?.data ?? [];
    return { rows: _OpportunityDetails };
  } catch (err) {
    return err;
  }
};

export const fetchProductInfo = async (payload) => {
  try {
    return await getRequest(`${ReportsOpportunityHistory}/${payload}/productdetails`);
  } catch (e) {
    return e;
  }
};

export const retrieveDeviceData = async (payload) => {
  try {
    return await postRequest(ReportsDeviceData, payload);
  } catch (err) {
    return err;
  }
};

export const retrieveVtuPageData = (payload, pageNo = 0, pageSize = 10) =>
  new Promise((res, rej) => {
    postRequest(`${ReportsVTUData}?pageNo=${pageNo}&pageSize=${pageSize}`, payload)
      .then((data) => res(data?.data?.data))
      .catch(({ response }) => rej(response.data));
  });

export const retrieveCameraPageData = (payload, pageNo = 0, pageSize = 10) =>
  new Promise((res, rej) => {
    postRequest(`${ReportsCameraData}?pageNo=${pageNo}&pageSize=${pageSize}`, payload)
      .then((data) => res(data?.data?.data))
      .catch(({ response }) => rej(response?.data));
  });

export const checkCFStatus = (payload) =>
  new Promise((res, rej) => {
    postRequest(CFWARRANTYSTATUS, payload)
      .then((data) => res(data?.data?.data))
      .catch(({ response }) => rej(response?.data));
  });

export const retrieveJobsPageData = (payload, pageNo = 0, pageSize = 10) =>
  new Promise((res, rej) => {
    postRequest(`${Reports360JobsData}?pageNo=${pageNo}&pageSize=${pageSize}`, payload)
      .then((data) => res(data?.data?.data))
      .catch(({ response }) => rej(response?.data));
  });

export const retrieveWorkticketsPageData = (payload, pageNo = 0, pageSize = 10) =>
  new Promise((res, rej) => {
    postRequest(`${Reports360WorkticketsData}?pageNo=${pageNo}&pageSize=${pageSize}`, payload)
      .then((data) => res(data?.data?.data))
      .catch(({ response }) => rej(response?.data));
  });

export const retrieveJobsCsvPageData = async (payload) => {
  const headers = {
    "Content-Type": "application/json",
    Accept: "application/zip",
  };
  // Ensure responseType: 'blob' is set for Axios
  const response = await postRequest(Reports360JobsCsvData, payload, { headers, responseType: "blob" });

  // Axios puts the blob in response.data if responseType is 'blob'
  if (response && response.data instanceof Blob) {
    return response;
  }
  throw new Error("No valid ZIP or Blob data returned");
};

export const retrieveWorkticketsCsvPageData = async (payload) => {
  const headers = {
    "Content-Type": "application/json",
    Accept: "application/zip",
  };
  // Ensure responseType: 'blob' is set for Axios
  const response = await postRequest(Reports360WorkticketsCsvData, payload, { headers, responseType: "blob" });

  // Axios puts the blob in response.data if responseType is 'blob'
  if (response && response.data instanceof Blob) {
    return response;
  }
  throw new Error("No valid ZIP or Blob data returned");
};
